/* ============================================================================
   drb-devanture.js — refonte « Devanture » (LOTS 1-3, 04/10/2026, validée par Benoit le 04/10).
   Chargé une fois en defer depuis layout/theme.liquid, APRÈS drb-portal.js. Ne remplace rien de drb-portal.js :
   l'ajout au panier reste le bouton [data-drb-add] (drb-portal.js) ; ce fichier ne fait que :
     1. le sélecteur par carton des cartes (.dv-c) : quantité, palier atteint, prix unitaire et prix du carton,
        palier suivant, et data-drb-q du bouton Ajouter ;
     2. la date de livraison « livré mardi 6 oct. » ([data-dv-date]) avec la RÈGLE DE LA FICHE PRODUIT
        (assets/drb-b2b.js, livraison()) : expédition le jour même avant data-cutoff (12 h), sinon le jour ouvré
        suivant, week-end reporté au lundi, livraison à expédition + data-colis-j (2) jours ouvrés ;
     3. la recopie du panier dans l'en-tête (total HT et nombre de produits) depuis [data-drb-cartpill],
        que drb-portal.js continue d'écrire ;
     4. le panneau « Toutes les gammes » ;
     5. les rangées de cartes défilantes (flèches) et le texte court de la recherche au mobile ;
     6. en vue Vignettes des collections / recherche, le palier atteint et le prix du carton suivent la quantité.
   Idempotent : garde window.__drbDevantureLoaded.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__drbDevantureLoaded) return;
  window.__drbDevantureLoaded = true;

  /* ---------- formats (mêmes règles que snippets/drb-prix3.liquid) ---------- */
  function prix(v) { var m = Math.round(v * 1000); var s = (m % 10 === 0 ? (m / 1000).toFixed(2) : (m / 1000).toFixed(3)); return s.replace('.', ',') + ' €'; }
  function eur(v) { return v.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
  function nb(x) { return String(x).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); }

  /* ---------- 2. date de livraison : règle de la fiche produit ---------- */
  function drbFerie(d){var y=d.getFullYear(),k=(d.getMonth()+1)*100+d.getDate();if([101,501,508,714,815,1101,1111,1225].indexOf(k)>=0)return true;var a=y%19,b=Math.floor(y/100),c=y%100,e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-Math.floor(b/4)-g+15)%30,l=(32+2*e+2*Math.floor(c/4)-h-c%4)%7,m=Math.floor((a+11*h+22*l)/451),p=new Date(y,Math.floor((h+l-7*m+114)/31)-1,((h+l-7*m+114)%31)+1);return [1,39,50].some(function(o){var q=new Date(p);q.setDate(q.getDate()+o);return (q.getMonth()+1)*100+q.getDate()===k;});} function isBizD(d){var w=d.getDay();return w!==0&&w!==6&&!drbFerie(d);} function addBiz(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (isBizD(x)) n--; } return x; }
  function dateLivraison(cutoff, colisJ) {
    var exp = new Date();
    if (exp.getHours() >= cutoff) exp = addBiz(exp, 1);
    while (!isBizD(exp)) exp = addBiz(exp, 1);
    return addBiz(exp, colisJ);
  }
  function fillDates(root) {
    (root || document).querySelectorAll('[data-dv-date]:not([data-dv-ok])').forEach(function (el) {
      var c = parseInt(el.getAttribute('data-cutoff'), 10); if (isNaN(c)) c = 12;
      var j = 1; /* règle Benoit 04/10/2026 : expédition + 1 jour ouvré */
      var d = dateLivraison(c, j);
      el.textContent = 'livraison Chronopost';
      el.setAttribute('data-dv-ok', '1');
    });
  }

  /* bande de service : délai de livraison (Benoit 05/10/2026 : un délai, plus de date) */
  function fillLivrMsg() {
    var now = new Date(), avant = isBizD(now) && now.getHours() < 12, we = now.getDay() === 0 || now.getDay() === 6, exp = new Date(now);
    if (!avant) exp = addBiz(exp, 1);
    while (!isBizD(exp)) exp = addBiz(exp, 1);
    var d = addBiz(exp, 1), lg = d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'short' }), ct = d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
    var txt = 'Chronopost';   /* 07/10/2026 : plus aucun délai */
    document.querySelectorAll('[data-drb-livr-msg]').forEach(function (el) { el.innerHTML = 'Livraison <strong>' + txt + '</strong>'; });
    document.querySelectorAll('[data-drb-livr-mob]').forEach(function (el) { el.innerHTML = 'Livraison Chronopost · <strong>franco 250 € HT</strong>'; });
    document.querySelectorAll('.drb-kpi--carrier').forEach(function (c) { var b = c.querySelector('.drb-kpi__top b'), sp = c.querySelector(':scope > span'); if (b) b.textContent = 'Livraison suivie'; if (sp) sp.textContent = 'en Chronopost, colis et palettes'; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fillLivrMsg); else fillLivrMsg();

  /* ---------- 1. cartes : sélecteur par carton ---------- */
  function tiersOf(card) { try { return (JSON.parse(card.getAttribute('data-tiers') || '[]') || []).slice().sort(function (a, b) { return a.q - b.q; }); } catch (e) { return []; } }
  function tierIndex(tiers, q) { var k = 0; for (var i = 0; i < tiers.length; i++) if (tiers[i].q <= q) k = i; return k; }
  function paintPal(ul, tiers, idx, uLbl) {
    if (!ul || tiers.length < 2) return;
    var start = Math.min(idx, Math.max(0, tiers.length - 3)), html = '';
    for (var i = start; i < Math.min(tiers.length, start + 3); i++) html += '<li' + (i === idx ? ' class="on"' : '') + '><span>dès ' + nb(tiers[i].q) + ' ' + uLbl + '</span><b>' + prix(tiers[i].pv) + '</b></li>';
    ul.innerHTML = html;
    var plus = ul.parentNode.querySelector('[data-dv-plus]');
    if (plus) plus.hidden = start + 3 >= tiers.length;
  }
  function paintCard(card, q) {
    var pcb = +card.getAttribute('data-pcb') || 1, min = +card.getAttribute('data-min') || pcb, uc = +card.getAttribute('data-uc') || 0;
    q = Math.max(min, q);
    card._q = q;
    var uLbl = uc > 0 ? 'cart.' : 'u.';
    var out = card.querySelector('[data-dv-q]'); if (out) out.innerHTML = nb(q) + '<small>' + uLbl + '</small>';
    var add = card.querySelector('[data-drb-add]'); if (add) add.setAttribute('data-drb-q', q);
    var minus = card.querySelector('[data-dv-step="-1"]'); if (minus) minus.disabled = q <= min;
    var tiers = tiersOf(card); if (!tiers.length) return;
    var idx = tierIndex(tiers, q), pv = tiers[idx].pv;
    var pu = card.querySelector('[data-dv-pu]'), pc = card.querySelector('[data-dv-pc]');
    if (uc > 0) { if (pu) pu.textContent = eur(pv); }
    else {
      if (pu) pu.textContent = prix(pv);
      if (pc) { var nC = min > pcb && min % pcb === 0 && q === min ? min / pcb : 1; pc.textContent = eur(pv * pcb * nC) + ' HT ' + (nC > 1 ? 'les ' + nC + ' cartons' : 'le carton'); }
    }
    paintPal(card.querySelector('[data-dv-pal]'), tiers, idx, uLbl);
    var nx = card.querySelector('[data-dv-next]');
    if (nx) {
      var t = tiers[idx + 1];
      if (t && q > min) { var n = Math.ceil((t.q - q) / pcb); nx.textContent = 'Encore ' + n + ' carton' + (n > 1 ? 's' : '') + ' pour passer à ' + prix(t.pv) + ' HT'; nx.hidden = false; }
      else nx.hidden = true;
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-dv-step]'); if (!b) return;
    var card = b.closest('[data-dv-c]'); if (!card) return;
    e.preventDefault();
    var pcb = +card.getAttribute('data-pcb') || 1, min = +card.getAttribute('data-min') || pcb;
    var q = card._q || min;
    paintCard(card, q + (+b.getAttribute('data-dv-step')) * pcb);
  });
  function initCards(root) {
    (root || document).querySelectorAll('[data-dv-c]:not([data-dv-init])').forEach(function (c) {
      c.setAttribute('data-dv-init', '1');
      var m = c.querySelector('[data-dv-step="-1"]'); if (m) m.disabled = true;
    });
  }

  /* ---------- 6. vue Vignettes : palier atteint et carton suivent la quantité de la ligne ---------- */
  function paintRow(row) {
    var rc = row.querySelector('[data-dv-rc]'); if (!rc) return;
    var p; try { p = JSON.parse(row.querySelector('script[data-drb-p]').textContent); } catch (e) { return; }
    var tiers = (p.tiers || []).slice().sort(function (a, b) { return a.q - b.q; }); if (!tiers.length) return;
    var inp = row.querySelector('input[data-drb-q]'), q = inp ? parseInt(inp.value, 10) || 0 : 0;
    var qq = Math.max(q, p.min || 1), idx = tierIndex(tiers, qq), pcb = +rc.getAttribute('data-pcb') || 1, uc = +rc.getAttribute('data-uc') || 0;
    paintPal(rc.querySelector('[data-dv-pal]'), tiers, idx, uc > 0 ? 'cart.' : 'u.');
    var plus = rc.querySelector('.dv-rc__plus'); if (plus) plus.hidden = Math.min(idx, Math.max(0, tiers.length - 3)) + 3 >= tiers.length;
    var pc = rc.querySelector('[data-dv-pc]'); if (pc && !uc) pc.textContent = eur(tiers[idx].pv * pcb) + ' HT le carton';
  }
  function onRowEvent(e) {
    var row = e.target.closest && e.target.closest('.drb-row[data-drb-row]'); if (!row) return;
    setTimeout(function () { paintRow(row); }, 30);
  }
  document.addEventListener('click', onRowEvent);
  document.addEventListener('change', onRowEvent);

  /* ---------- 3. panier de l'en-tête ---------- */
  function syncCart() {
    document.querySelectorAll('[data-dv-cart]').forEach(function (a) {
      var src = a.querySelector('[data-drb-cartpill]'); if (!src) return;
      var t = (src.textContent || '').replace(/\s+/g, ' ').trim();
      var n = 0, tot = '0,00 € HT';
      if (!/vide/i.test(t)) {
        var mn = t.match(/(\d+)\s*produit/); if (mn) n = +mn[1];
        var mt = t.match(/([\d\s  .,]+€)\s*HT/); if (mt) tot = mt[1].trim() + ' HT';
        if (!mn && mt) n = +(a.getAttribute('data-dv-n') || 1);
      }
      a.setAttribute('data-dv-n', n);
      var to = a.querySelector('[data-dv-carttot]'); if (to && to.textContent !== tot) to.textContent = tot;
      var nn = a.querySelector('[data-dv-cartn]'); if (nn) { nn.textContent = n; nn.hidden = !n; }
      a.setAttribute('aria-label', 'Panier, ' + n + ' produit' + (n > 1 ? 's' : '') + ', ' + tot);
    });
  }

  /* ---------- 4. panneau « Toutes les gammes » ---------- */
  function setAll(open) {
    var b = document.querySelector('[data-dv-all]'), p = document.getElementById('dv-allg'); if (!b || !p) return;
    p.hidden = !open; b.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-dv-all]');
    if (b) { e.preventDefault(); setAll(b.getAttribute('aria-expanded') !== 'true'); return; }
    var p = document.getElementById('dv-allg');
    if (p && !p.hidden && !e.target.closest('#dv-allg')) setAll(false);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { var p = document.getElementById('dv-allg'); if (p && !p.hidden) { setAll(false); var b = document.querySelector('[data-dv-all]'); if (b) b.focus(); } } });

  /* ---------- 5. rangées défilantes ---------- */
  function initTracks() {
    document.querySelectorAll('[data-dv-trackbox]').forEach(function (box) {
      if (box._dv) return; box._dv = true;
      var sec = box.closest('.dv-sec') || box.parentNode, nav = sec.querySelector('[data-dv-tracknav]');
      function maj() {
        var over = box.scrollWidth > box.clientWidth + 4;
        if (nav) nav.hidden = !over;
        if (!nav) return;
        var prev = nav.querySelector('[data-dv-track="-1"]'), next = nav.querySelector('[data-dv-track="1"]');
        if (prev) prev.disabled = box.scrollLeft <= 2;
        if (next) next.disabled = box.scrollLeft + box.clientWidth >= box.scrollWidth - 2;
      }
      if (nav) nav.addEventListener('click', function (e) {
        var b = e.target.closest('[data-dv-track]'); if (!b) return;
        var it = box.querySelector('.dv-track__it'), w = it ? it.getBoundingClientRect().width + 24 : box.clientWidth;
        box.scrollBy({ left: (+b.getAttribute('data-dv-track')) * w, behavior: 'smooth' });
      });
      box.addEventListener('scroll', function () { window.requestAnimationFrame(maj); }, { passive: true });
      window.addEventListener('resize', maj);
      maj();
    });
  }

  /* ---------- texte court de la recherche au mobile ---------- */
  function phMobile() {
    var i = document.getElementById('Search-Drb'); if (!i || !i.getAttribute('data-dv-ph-mob')) return;
    if (!i._ph) i._ph = i.getAttribute('placeholder');
    var mob = window.matchMedia && window.matchMedia('(max-width:749px)').matches;
    i.setAttribute('placeholder', mob ? i.getAttribute('data-dv-ph-mob') : i._ph);
  }

  function init() {
    fillDates(); initCards(); initTracks(); syncCart(); phMobile();
    document.querySelectorAll('[data-drb-cartpill]').forEach(function (p) { new MutationObserver(syncCart).observe(p, { childList: true, characterData: true, subtree: true }); });
    var tm = null;
    new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(function () { fillDates(); initCards(); initTracks(); }, 80); }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', phMobile);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
